export const tryParseJSON = (input: string) => {
  try {
    return JSON.parse(input);
  } catch (error) {
    return null;
  }
};
